<template>
    <header id="navigation-bar" class="fixed-top d-flex justify-content-center align-items-center">

        <slot></slot>

        <img id="navigation-bar-logo" class="h-100 py-3" src="/images/imagotipo-sticky.svg" alt="" height="2.5rem" hidden>

        <customer-area-button data-unavailable></customer-area-button>

    </header>
</template>

<script>
    export default {

        data: function () {
            return {
                //
            }
        },

        mounted: function () {
            /*
            if ( $('#main-logo').length ) {
                
                var inview = new Waypoint.Inview({
                    element: $('#main-logo'),
                    enter: function (direction) {
                        $('#navigation-bar').removeClass('sticky');
                    },
                    exited: function (direction) {
                        $('#navigation-bar').addClass('sticky');
                    }
                });

            } else if ( $('.intro-title').length ) {

                $('#navigation-bar').addClass('visible-logo');

                var inview = new Waypoint.Inview({
                    element: $('.intro-title'),
                    enter: function (direction) {
                        $('#navigation-bar').removeClass('sticky');
                    },
                    exit: function (direction) {
                        $('#navigation-bar').addClass('sticky');
                    }
                });
            }
            ^*/
        },

        methods: {
            //
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-bar {
        height: 4rem;
        transition: transform .4s linear .8s, background-color .4s linear .8s;
        transform: translate3d(0, -5rem, 0);
        background-color: rgba(255,255,255,0);
        box-shadow: 0 .1rem .25rem rgba(0,0,0,.1);

        #customer-area, 
        #navigation-bar-menu {
            transform: translate3d(0, 5rem, 0);
            transition: transform .4s linear .8s;
        }

        #customer-area small {
            transition: color .4s linear .8s;
        }

        > #navigation-bar-logo {
            position: relative;
            opacity: 0;
            transition: transform .4s linear 0s, opacity .4s linear 0s;
            transform: translate3d(0, -2rem, 0);
        }

        &.sticky {
            background-color: rgba(255,255,255,.8);
            transition-delay: 0s;
            transform: translate3d(0, 0, 0);

            #customer-area, 
            #navigation-bar-menu {
                transform: translate3d(0, 0, 0);
                transition-delay: 0s;
            }

            #customer-area small {
                transition-delay: 0s;
            }

            > #navigation-bar-logo {
                opacity: 1;
                transform: translate3d(0, 0, 0);
                transition-delay: .8s;
            }

            #customer-area small {
                color: inherit;
                transition-delay: .4s;
            }
        }

        &.visible-logo {
            
            > #navigation-bar-logo {
                opacity: 1;
                transition-delay: 0s;
            }

            &:not(.sticky) > #navigation-bar-logo {
                transform: translate3d(0, 5rem, 0);
                transition: transform .4s linear .8s, opacity .4s linear 0s;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/NavigationBar.vue